export default "__VITE_ASSET__Cu9Zr7Jr__"